import axios from 'axios';
import { config } from '../../config';

export function getTotalPoints({ userId }) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/chain/total-points`,
  };
}

export function getLatestReward({}) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/chain/latest-reward`,
  };
}

export function getTotalRewards({}) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/chain/total-rewards`,
  };
}

export function getCharterById({ charterKey }) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/chain/charter/${charterKey}`,
  };
}

export function getCharters() {
  return {
    method: 'GET',
    url: `${config.backend.giveUrl}/charter`,
  };
}

// export function getCharters() {
//   return {
//     method: 'GET',
//     url: `${config.core.membershipServiceUrl}/api/chain/charters`,
//   };
// }

export function getUserVoteByCharter({ charterKey }) {
  return {
    method: 'GET',
    url: `${config.backend.giveUrl}/charter/${charterKey}/user-vote`,
  };
}

// export function getAllVotesByCharter({ charterKey }) {
//   return {
//     method: 'GET',
//     url: `${config.backend.giveUrl}/charter/${charterKey}/votes`
//   }
// }

export function getAllUserVotes({}) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/chain/votes`,
  };
}

export function createUserVote({ userId, charterId, voteFor }) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/api/chain/votes`,
    data: {
      userId: userId,
      charterId: charterId,
      voteFor: voteFor,
    },
  };
}

//will change when chain gets this implemented in their code, right now it is an open api. Returned balance is hashed - parseInt(amount, 16)
export function getUserTokenBalance(walletAddress, url) {
  return axios({
    method: 'POST',
    url: url,
    data: {
      jsonrpc: '2.0',
      method: 'eth_getBalance',
      params: [walletAddress, 'latest'],
      id: 1, //id is a required param but not checked so for now this can just remain 1 at all times
    },
  }).then(({ data }) => data);
}
